import { render, staticRenderFns } from "./CartRecommendations.vue?vue&type=template&id=6b587bec&"
import script from "./CartRecommendations.vue?vue&type=script&lang=js&"
export * from "./CartRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MiniCartSlider: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/MiniCartSlider.vue').default})
